import type { Theme } from './types'

export const modern: Theme = {
  name: 'Modern Bold',
  isDark: true,
  font: "'Space Grotesk', -apple-system, sans-serif",
  colors: {
    bg: '#0a0a0a',
    bgSubtle: '#1a1a1a',
    text: '#ffffff',
    textSecondary: '#b0b0b0',
    textTertiary: '#777777',
    accent: '#00ff88',
    accentHover: '#00cc6a',
    accentSoft: 'rgba(0, 255, 136, 0.1)',
    accentText: '#0a0a0a',
    border: '#2a2a2a',
    userBubble: '#1f1f1f',
    progressBg: '#2a2a2a',
    wrapperBg: '#000000',
    disabledBg: '#2a2a2a',
    disabledText: '#666666',
    inputBg: '#1a1a1a',
  },
  radiusSm: '4px',
  radiusMd: '8px',
  radiusLg: '12px',
  radiusXl: '16px',
  shadow: '0 4px 16px rgba(0,255,136,0.1)',
  buttonStyle: 'sharp',
}
